import Logger from './logger';
import * as Checks from './ignore.checks';

const ignoreConditions = [
    (args) => {
        if (args && args.orderNumber && args.orderDetails) {
            if (Checks.isPurchaseWithNoItems(args.orderDetails)) return true;
            if (Checks.isOneTimePayment(args.orderDetails)) return true;
            if (Checks.isListedProductsPurchased(args.orderDetails)) return true;
        }
        return false;
    },
    (args) =>
        args &&
        args.tags &&
        args.tags.some((t) => t === 'digital_assist') &&
        !window.WC._cookies.getCookie('_snrs_uuid'),
    (args) =>
        args &&
        args.tags &&
        args.tags.some((t) => t === 'digital_assist') &&
        window.WC.Closer.isOpen()
];

const shouldIgnore = (args, callbacks) => {
    try {
        return ignoreConditions.some((c) => c(args, callbacks));
    } catch (error) {
        Logger.error('Error in shouldIgnore:', error);
        return false;
    }
};

export { shouldIgnore };
